import { jsx as _jsx } from "react/jsx-runtime";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./styles.css.js";
function Handle(props, ref) {
    function handlePointerDown(event) {
        var _a;
        if (event.button !== 0) {
            return;
        }
        (_a = props.onPointerDown) === null || _a === void 0 ? void 0 : _a.call(props, event);
    }
    return (_jsx("button", { ...props, onPointerDown: handlePointerDown, className: clsx(styles.handle, props.className), ref: ref }));
}
export default forwardRef(Handle);
